export default __webpack_public_path__ + "static/media/module-download-icon.0ca07197.svg";